import { url } from '../config/config';
import axios from 'axios';
// import config from 'config';
// export const authenticationService = {
//     login,
//     logout
// }

class Auth {
    constructor() {
        this.token = JSON.parse(localStorage.getItem("currentUser"));
        this.mobile = localStorage.getItem("mobile");
    }

    isAuthenticated() {
        return this.token != null && new Date().getTime() < this.token.expire;
    }

    getAuthToken(){
        return this.token.token;
    }

    getMobileNo() {
        return this.mobile;
    }

    signOut() {
         // remove user from local storage to log user out
         localStorage.removeItem('currentUser');
         localStorage.removeItem("mobile");
         this.token = null;
    }

    async sendOtp(mobileNo) {
        return axios.post(`${url}supplier/otp`, null, { params: { "mobileNo": mobileNo } });
    }

    async login(username, password) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                'username': username,
                'password': password
            })
        };

        return fetch(`${url}supplier/login`, requestOptions)
            // .then(handleResponse)
            .then(response => {
                
               return  response.text().then(text => {
                    const data = text && JSON.parse(text);
                    if (!response.ok) {
                        
                        const error = (data && data.message) || response.statusText;
            
                        return Promise.reject(error);
                    }
            
                    return data;
                });
            })
            
            .then(user => {
                // console.log(user);
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.token = user;
                this.mobile = username;
                localStorage.setItem("mobile", username);
                // currentUserSubject.next(user);

                return user;
            });
    }



}

const authenticationService = new Auth();

export default authenticationService;